export const TOKEN_KEY: string = "sid";
export const LANGUAGE_KEY: string = "lang";
export const PERMISSION_KEY: string = "permission";